import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadProductDetails } from "../../store/actions/store";
import lazyView from "./lazyView";
import { loadProductPage } from "./productPageLoader";
import { shouldHydrateProductDetails } from "./productDetailsHydration";
import "./ProductPageRoute.css";

export function ProductPagePreview({ history, error, onRetry }) {
  const product = useSelector(state => state.store?.current_product);
  const arabic = useSelector(state => state.store?.language === "arabic");
  const name = arabic ? product?.ar_name || product?.name : product?.name;
  const image = product?.photo_medium || product?.photo_small || product?.photo;
  return <section className="product-page-preview" dir={arabic ? "rtl" : "ltr"} aria-busy={!error}>
    <div className="product-page-preview__nav">
      <button type="button" onClick={() => history?.goBack()} aria-label={arabic ? "رجوع" : "Back"}>
        {arabic ? "→" : "←"}
      </button>
    </div>
    {image && <img className="product-page-preview__image" src={image} alt={name || ""} />}
    <div className="product-page-preview__body">
      {name && <h1>{name}</h1>}
      {error ? <div role="alert">
        <p>{arabic ? "تعذر تحميل تفاصيل المنتج. حاول مرة أخرى." : "We couldn’t load the product details. Please try again."}</p>
        <button type="button" onClick={onRetry}>{arabic ? "إعادة المحاولة" : "Try again"}</button>
      </div> : <>
        <p role="status" aria-live="polite">{arabic ? "جارٍ تحميل تفاصيل المنتج…" : "Loading product details…"}</p>
        <div className="product-page-preview__skeleton" aria-hidden="true"><span /><span /><span /></div>
      </>}
    </div>
  </section>;
}

const DeferredProductPage = lazyView(loadProductPage, ProductPagePreview);

export default function ProductPageRoute(props) {
  const product = useSelector(state => state.store?.current_product);
  const dispatch = useDispatch();
  const entered = useRef(false);
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const id = product?.id;
  const category = product?.category_id;
  const loaded = !shouldHydrateProductDetails(null, product);
  useEffect(() => {
    // Both start in this commit; data no longer waits for the route chunk.
    loadProductPage().catch(() => {});
    if (entered.current || !id) return;
    let active = true;
    if (loaded) setResult({ id, ok: true });
    else dispatch(loadProductDetails(id, category)).then(ok => {
      if (active) setResult({ id, ok });
    });
    return () => { active = false; };
  }, [dispatch, id, category, attempt, loaded]);

  if (!entered.current && id) {
    if (result?.id !== id || !result.ok) {
      return <ProductPagePreview {...props} error={result?.id === id && result.ok === false}
        onRetry={() => { setResult(null); setAttempt(value => value + 1); }} />;
    }
    entered.current = true;
  }
  // Once mounted, retain the existing PDP lifecycle for variant changes,
  // booking selections, editing a cart item, and direct-link resolution.
  return <DeferredProductPage {...props} />;
}
